import { useNetworkMutation, useNetworkRequest } from '@/lib/utils/request'

export type OrganizationSettings = {
  vehicleOfflineAfter: number | null
  misc?: Record<string, unknown> | null
}

export type PatchedOrganizationSettings = Partial<OrganizationSettings>

export const useSettings = () =>
  useNetworkRequest<OrganizationSettings>(
    {
      url: 'v1/organizations/my/settings/',
      config: {
        retry: 0,
      },
    },
    {
      shouldRetryOnError: false,
      fallbackData: undefined,
    },
  )

export const usePatchSettings = () =>
  useNetworkMutation<OrganizationSettings, PatchedOrganizationSettings>({
    url: 'v1/organizations/my/settings/',
    method: 'patch',
  })
